var React = require('react');

function IcSortComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-sort"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M2.75 14.75V13.5833H7.25V14.75H2.75ZM2.75 10.5833V9.41667H12.25V10.5833H2.75ZM2.75 6.41667V5.25H17.25V6.41667H2.75Z","fill":"#006736"})));
}

IcSortComponent.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = IcSortComponent;

IcSortComponent.default = IcSortComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/ResultsSectionV2/images/ic-sort.component.svg
// module id = 1649
// module chunks = 0